import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ResolverService } from '../../___LOGIC/__common/resolver.service';
import { StudyCenterDetailsComponent } from '../study-center-details/study-center-details.component';
import { ApiConnectorService } from '../../___LOGIC/__api/api-connector.service';

@Component({
  selector: 'app-study-options',
  templateUrl: './study-options.component.html',
  styleUrls: ['./study-options.component.css']
})
export class StudyOptionsComponent implements OnInit {

  displayedColumns: string[] = ['name', 'type', 'ranking', 'rating', 'location', 'actions'];
  dataSource: MatTableDataSource<any>;
  columnFilters = {};

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(public dialog: MatDialog,private resolver: ResolverService,private apiConnector: ApiConnectorService) {
    /* this.resolver.getBackendDataForQueryId('get',true,'studyCenter'); */
  }

  ngOnInit(): void {
    this.apiConnector.voyjaleasApiRequest('get','studyCenter',null,null,null,null)
      .subscribe(
        (response) => {
          this.dataSource = new MatTableDataSource(response.records);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.dataSource.filterPredicate = this.customFilterPredicate();
        },
        (error) => {
          /* this.guiFlow.openSimpleSnackBar('Error, unable to insert',""); */
        console.log('Error creating object. Generic [POST]')
        }
      );
  }

  applyGlobalFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  applyColumnFilter(event: Event, column: string): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.columnFilters[column] = filterValue.trim().toLowerCase();
    this.dataSource.filter = JSON.stringify(this.columnFilters);

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  customFilterPredicate(): (data: any, filter: string) => boolean {
    const filterFunction = (data: any, filter: string): boolean => {
      const searchTerms = JSON.parse(filter);
      let isMatch = true;

      for (const key in searchTerms) {
        if (searchTerms[key] && data[key].toString().toLowerCase().indexOf(searchTerms[key]) === -1) {
          isMatch = false;
          break;
        }
      }
      return isMatch;
    };
    return filterFunction;
  }

  viewDetails(element: any): void {
    this.dialog.open(StudyCenterDetailsComponent, {
      width: '400px',
      data: element
    });
  }

  ngAfterViewInit() {
    this.dataSource.filterPredicate = this.customFilterPredicate();
  }
}